<template>
<div>
    <div :class="menuFlag ? 'menu-icon show-m' : 'menu-icon hide-m'" @click="menuShow" role="button" aria-label="展开主菜单"><i class="b-icon b-kuaijierukou" style="font-size: .7rem;margin-left: .1rem;"></i></div>
    <div :class="menuFlag ? 'b-menu-main hide hideA' : 'b-menu-main show showA'">
        <div class="relative icon-flex">
            <div v-for="(item, index) in menuList" :key="index" @click="menuFc(item)" :class="'center menu-main ' + item.color" role="button">
                <h4 class="stor-icon" v-if="item.icon == 'stor' && item.val != 0">{{item.val}}分</h4>
                <i :class="'b-icon b-' + item.icon" :aria-label="item.explain" v-else></i>
            </div>
        </div>
        <div class="center menu-main green" role="button" aria-label="返回首页" @click="goUrl('home')" v-show="back != false">
            <i class="b-icon b-fanhuishouye-01" style="font-size: .65rem;"></i>
        </div>
        <div class="center menu-main orange" role="button" aria-label="返回顶部" v-show="backTop && backTop == true" @click="goTop">
            <i class="b-icon b-top"></i>
        </div>
    </div>
</div>
</template>

<script>
import { Rate, Toast } from 'vant'
import common from '@/assets/js/common.js'
export default {
    name: 'Menu',
    props: ['menuList', 'backTop', 'back'],
    data () {
        return {
            menuFlag: false,
            show: false,
            shia: false,
            timer: null
        }
    },
    components: {
        Rate
    },
    created  () {
        this.setTimer()
    },
    methods: {
        setTimer () {
            var that = this
            if (that.menuFlag == false) {
                this.timer = setInterval(() => {
                that.menuFlag = true
                clearInterval(that.timer)
                that.timer = null
                }, 10000)
            }
        },
        menuShow () {
            clearInterval(this.timer)
            this.timer = null
            this.menuFlag = false
            this.setTimer()
        },
        goUrl (name, v, flag) {
            common.goRouter(this, name, v, flag)
        },
        // 返回顶部
        goTop () {
            this.$emit('goTop')
        },
        // 点击按钮图标
        menuFc (obj) {
            if (obj.router) {
                this.goUrl(obj.router)
            } else if (obj.icon == 'stor') { // 评分
                if (obj.val === 0) {
                    this.show = !this.show
                } else {
                    Toast('你已评分')
                }
            } else if (obj.icon == 'wodekecheng-01') {
                this.goUrl('myCourse')
            } else if (obj.icon == '1_fuzhi-01') { // 生成上图
                this.$emit('canvasImage')
            } else {
                this.$emit('menuCallback')
            }
        }
    }
}
</script>

<style lang="less" scoped>
.b-menu-main {
    position: fixed;
    bottom: 1.5rem;
    z-index: 9;
    .show {opacity: 1;}
    .hide {opacity: 0;}
    .icon-flex {
        display: flex;
        flex-direction: column;
        .menu-main {
            z-index: 2;overflow: hidden;
            .stor-icon {
                width: .98rem;
                height: .98rem;
                line-height: .98rem;
                margin: -.02rem;
                font-size:.3rem;background: #00c4a3;color:#fff;border-radius: 50%;
            }
            .b-1_fuzhi-01 {font-size: .7rem;}
        }
        .scalar {
            width: 4.6rem;
            height: .94rem;
            line-height: .94rem;
            position: absolute;
            right: 0;
            top: 0;
            border-radius: 1rem;
            background: #fff;
            transition: all 0.5s;
            box-shadow: 0 0rem 0.2rem 0rem rgba(0, 0, 0, 0.16);
        }
    }
    .menu-main {
        width: .94rem;
        height: .94rem;
        line-height: .94rem;
        border-radius: 50%;
        margin-bottom: .26rem;box-shadow: 0 .1rem .2rem rgba(0, 0, 0, 0.14);
        i {font-size: .5rem;}
        i.b-gongduzhuanlan {font-size: .65rem;}
        i.b-1,i.b-2 {font-size: .7rem;}
        i.b-wodekecheng-01{font-size: 0.74rem;}
    }
    .green {
        color: #00c4a3;
        background: #ebfff9;
        border: 1px solid #00c4a3;
    }
    .orange {
        color: #ffa538;
        background: #fff6eb;
        border: 1px solid #ffa538;
    }
    .dark-blue {
        color: #76a5f3;
        background: #f0f7ff;
        border: 1px solid #84b3ef;
    }
    .rose-red {
        color: #e95b83;
        background: #ffebf0;
        border: 1px solid #e47a98;
    }
}

.b-menu-main {transition: all 0.5s;}
.hideA {
    right: -1rem;
    opacity: 0;
}
.showA {
    right: .5rem;
    opacity: 1;
}
.menu-icon {
    position:fixed;
    right: 0;
    bottom: 1.5rem;
    transition: all 0.5s;
    width: .85rem;
    height: .85rem;
    border: 1px solid #01c4a3;
    display: inline-block;
    line-height: .85rem;
    text-align: center;
    border-radius: .8rem 0 0 .8rem;
    background: #01c4a3;
    color: #FFF;
    box-shadow: 0px 1px 6px 2px #00000029;
    z-index: 9;
    .b-icon {font-size: .46rem;}
}
.show-m {
    opacity: 1;
    transform: scale(1);
}
.hide-m {
    opacity: 0;
    transform: scale(0);
}
</style>


// WEBPACK FOOTER //
// src/components/base/hover_menu.vue